import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'
import type { IAction } from '@ztechapps/common.contract'
import type { ScanBatch } from '../entities/ScanBatch'

@InputType()
export class EnqueueBatchScanArgs extends ActionArgs {
  @Field(() => ID)
  assessmentId: string

  @Field(() => [String])
  imageUrls: string[]
}

export interface IEnqueueBatchScan extends IAction<ScanBatch, EnqueueBatchScanArgs> {}
